import { memo, useMemo } from 'react'
import { Image } from 'antd'

interface GalleyImageProps<T = any> {
  items: T[]
}

const GalleyImage = memo<GalleyImageProps>(({ items }) => {
  const { firstCol, lastCol, firstRow, lastRow } = useMemo(() => {
    if (items.length === 4) {
      return {
        firstCol: 2,
        lastCol: 2,
        firstRow: items.slice(0, 2),
        lastRow: items.slice(2, 4),
      }
    }
    const firstCol = items.length % 3 === 0 ? 3 : items.length % 3
    const firstRow = items.slice(0, firstCol)
    const lastRow = items.slice(firstCol, items.length)
    const lastCol = lastRow.length > 2 ? 3 : lastRow.length

    return {
      firstCol,
      lastCol,
      firstRow,
      lastRow,
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items])

  return (
    <div className="flex flex-col gap-1 md:gap-2 w-96 max-w-full">
      <div
        className={`grid ${
          firstCol === 1
            ? 'grid-cols-1'
            : firstCol === 2
              ? 'grid-cols-2'
              : 'grid-cols-3'
        } gap-1 md:gap-2`}
      >
        {firstRow.map(i => (
          <div key={i.src} className="rounded-md overflow-hidden">
            <Image
              key={i.src}
              width="100%"
              className="aspect-square object-cover"
              src={i.src}
            />
          </div>
        ))}
      </div>
      {lastRow.length > 0 && (
        <div
          className={`grid ${
            lastCol === 1
              ? 'grid-cols-1'
              : lastCol === 2
                ? 'grid-cols-2'
                : 'grid-cols-3'
          } gap-1 md:gap-2`}
        >
          {lastRow.map(i => (
            <div key={i.src} className="rounded-md overflow-hidden">
              <Image
                key={i.src}
                width="100%"
                className="aspect-square object-cover"
                src={i.src}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  )
})

export default GalleyImage
